var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-wizard-field-time" },
    [
      _c(
        "CompassFormItem",
        _vm._b({}, "CompassFormItem", _vm.formItemProps, false),
        [
          _c(
            "CompassTimePicker",
            _vm._b(
              {
                attrs: { menuClass: "automation-wizard-field-time" },
                on: { "update:value": _vm.handleInput },
                model: {
                  value: _vm.localValue,
                  callback: function($$v) {
                    _vm.localValue = $$v
                  },
                  expression: "localValue"
                }
              },
              "CompassTimePicker",
              _vm.timePickerProps,
              false
            )
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }